window.ModalDialog = class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;

    this.addEventListener('click', (event) => {
      if (event.target === this || event.target.hasAttribute('data-close-modal')) {
        this.close();
      }
    });
  }

  open() {
    this.classList.add('open');
    this.setAttribute('aria-hidden', 'false');
    this.isOpen = true;
  }

  close() {
    this.classList.remove('open');
    this.setAttribute('aria-hidden', 'true');
    this.isOpen = false;
  }
};
window.debounce = function (func, wait, immediate) {
  let timeout;
  return function () {
    const context = this, args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};
